(() => {
  /**=================================================================
   * Bundle Product Custom Element
   * =================================================================
  */
  void 0 === window.customElements.get("product-card-2") &&
    (window.customElements.define( 
      "product-card-2",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.tooltips = this.querySelectorAll(
              "[data-product-card-tooltip]"
            )),
            void 0 !== this.tooltips &&
              null !== this.tooltips &&
              this.initTooltips();
          this.initAddToCart();
        }
        initTooltips() {
          this.tooltips.forEach((t) => {
            this.initTippy(t);
          });
        }
        initTippy(t) {
          const e = t.getAttribute("data-product-card-tooltip"),
            a = t.getAttribute("data-product-card-tooltip-content");
          t.hasAttribute("data-product-card-tooltip-content") &&
            tippy(`[data-product-card-tooltip="${e}"]`, {
              content: a,
              duration: 300,
              interactive: !0,
              // Em: "put the price in the box" — the price is appended as
              // a small <span> pill into the tooltip's own content string
              // (see product-card-2.liquid). Tippy treats content as plain
              // text by default (tags would show up literally), so this is
              // needed for that span to actually render instead of the
              // customer seeing raw "<span>" text.
              allowHTML: !0,
            });
        }
        /* Featured Collection 2.0's "Add" button (data-quick-shop-trigger
           ="quick-add") has no click handling wired up anywhere in
           theme.js — unlike every other quick-add button in the theme
           (complete-the-look, shoppable-hero, products-slider-product),
           this one was just a plain product form, so clicking it did a
           full-page POST to /cart/add and landed on /cart instead of
           opening the quick cart. This adds an add-then-open-quick-cart
           behaviour to match.

           NOTE on the approach: theme.js's own quick-add buttons open the
           quick cart by emitting "quick-cart:open" / "quick-cart:updated"
           through a private, in-memory pub/sub instance that lives only
           inside theme.js's own closure — it is NOT wired to real DOM
           events, so document.dispatchEvent(new CustomEvent('quick-cart
           :open')) from this file (a separate script) can never reach it.
           "apps:product-added-to-cart" is the one quick-cart event that
           IS a genuine document-level DOM event (theme.js listens for it
           with addEventListener), which is why bundle-atc-form.js already
           relies on it to refresh the quick cart's contents. Actually
           revealing the drawer itself has no DOM-event hook at all, so —
           again matching bundle-atc-form.js's own toggleCartDrawer() —
           this opens it directly via the same DOM classes/attribute
           theme.js's openQuickCart() sets. */
        initAddToCart() {
          const form = this.querySelector('[data-quick-shop-trigger="quick-add"]')?.closest('form')
          if (!form) return
          form.addEventListener('submit', (e) => {
            e.preventDefault()
            this.handleAddToCart(form)
          })
        }
        openQuickCartDrawer() {
          const drawer = document.querySelector('.quick-cart__wrapper')
          const quickCart = document.querySelector('.quick-cart')
          if (!drawer || !quickCart || drawer.classList.contains('active')) return
          /* Clicking the header cart icon runs the theme's own
             openQuickCart() (scroll lock, focus trap, overlay="true").
             Manual class toggling is only a fallback. */
          const cartIcon = document.querySelector('[data-js-cart-icon]')
          if (cartIcon) {
            cartIcon.click()
            return
          }
          drawer.classList.add('active')
          quickCart.classList.add('animation--quick-cart-revealed')
          document.body.setAttribute('data-fluorescent-overlay-open', 'true')
        }
        async handleAddToCart(form) {
          const button = form.querySelector('[data-quick-shop-trigger="quick-add"]')
          if (!button || button.disabled) return

          const variantId = button.dataset.productId || form.querySelector('[name="id"]')?.value
          if (!variantId) return

          button.disabled = true
          button.classList.add('loading')

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            })

            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}))
              throw new Error(errorData.description || 'Could not add item to cart')
            }

            // Real DOM event — refreshes the quick cart's line items/count/subtotal.
            // Wait for that re-render to actually land before opening the
            // drawer (a fixed 300ms can be too short on a slow connection,
            // which leaves an invisible layer over the page after closing).
            const quickCart = document.querySelector('.quick-cart')
            const refreshed = new Promise(resolve => {
              if (!quickCart) return resolve()
              let done = false
              const finish = () => { if (done) return; done = true; observer.disconnect(); clearTimeout(timer); setTimeout(resolve, 50) }
              const observer = new MutationObserver(finish)
              observer.observe(quickCart, { childList: true, subtree: true })
              const timer = setTimeout(finish, 2500)
            })
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'))
            await refreshed
            this.openQuickCartDrawer()
          } catch (err) {
            console.error('Add to cart error:', err)
          } finally {
            button.disabled = false
            button.classList.remove('loading')
          }
        }
      })
    )

  if (typeof window.customElements.get('bundle-product') !== 'undefined') { return }
  window.customElements.define('bundle-product', class BundleProduct extends HTMLElement {
    constructor () {
      super()

      this.tooltips = this.querySelectorAll('[data-bundle-section-tooltip]')
      this.initTooltips()
    }

    initTooltips () {
      if (typeof this.tooltips === 'undefined' || this.tooltips === null) { return }

      this.tooltips.forEach(tooltip => {
        this.initTippy(tooltip)
      })
    }

    initTippy (tooltip) {
      const tooltipId = tooltip.getAttribute('data-bundle-section-tooltip')
      const tooltipContent = tooltip.getAttribute('data-bundle-section-tooltip-content')

      if (tooltip.hasAttribute('data-bundle-section-tooltip-addon')) {
        tippy(`[data-bundle-section-tooltip="${tooltipId}"]`, {
          content: tooltipContent,
          duration: 300,
          interactive: true,
          // Em: "put the price in the box" — see the product-card-2 tippy
          // call above for why this is needed (bundle-product-card.liquid
          // appends the price as a <span> into this same content string).
          allowHTML: true,
          placement: 'bottom',
          // Add-on cards live inside the horizontally-scrolling swiper
          // (.bundle-product__add-on / .bundle-product__option-collection),
          // which sets overflow: hidden / overflow-x: scroll. Tippy's
          // default appendTo renders the popup as a sibling of the "?"
          // trigger inside that same clipped container, so the bottom of
          // the popup — a bottom-placed tooltip needs room below the
          // trigger — got cut off instead of floating freely. Appending to
          // <body> takes it out of that clipped ancestor entirely.
          appendTo: () => document.body
          // Em: "'?' bubble glitching in mobile slider when sliding" —
          // several attempts to fix this (a hold-to-open delay, then a
          // manual touch/drag detection) each broke normal tapping
          // instead, so this is back to Tippy's plain default touch
          // behaviour — tapping works, the slide-glitch is still there.
        });
      } else {
        tippy(`[data-bundle-section-tooltip="${tooltipId}"]`, {
          content: tooltipContent,
          duration: 300,
          interactive: true
        });
      }
    }

    // initBundleList () {
    //   const bundleItemsData = sessionStorage.getItem('bundleList')
    //   if (bundleItemsData === null || bundleItemsData === '') { return }

    //   const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')

    //   bundleItemsJson.forEach(item => {
    //     const bundleItemEl = bundleItemTemplate(item.id, item.cid, item.quantity, item.sellingPlans, item.title, item.image, item.price, item.type, item.max)
    //     const doc = this.parser.parseFromString(bundleItemEl, 'text/html')
    //     const element = doc.querySelector('bundle-item')
    //     if (!element) { return }
    //     this.bundleList.appendChild(element)
    //   })
    // }
  })

  /* Em: "when i have a subscription in my cart and then i click edit, the
     page bundle is blank, i have to refresh the page to see the bundle".
     Two bugs compounding each other here:

     1) This was a METHOD on BundleQuantitySelector below, called from ITS
        OWN constructor — which runs the instant the FIRST
        bundle-quantity-selector element on the page is parsed/upgraded,
        well before the rest of the bundle-product page's markup (other
        product options, the subscription widget, etc.) is necessarily in
        the DOM yet. Every `document.querySelector(...)` check inside it
        silently no-ops when its target isn't there yet, but the function
        still marks window.__bundleStateRestored = true at the end
        regardless — so on a page load where that race went the wrong way,
        the bundle restores incompletely (or not at all) and nothing ever
        retries.

     2) A second, properly-timed retry was ALSO attempted — a
        <bundle-product-container> custom element whose constructor
        called this 500ms after DOMContentLoaded, by which point
        everything really is ready. Two bugs there, not one: it called
        `this.restoreBundleStateFromURL()`, and that class never defined
        that method itself (it lived only on BundleQuantitySelector, a
        different, unrelated custom element) — so that call always threw
        immediately (uncaught, inside a setTimeout, so silently). But even
        with that fixed, the retry still wouldn't run: no template
        anywhere actually contains a <bundle-product-container> element
        (the real wrapper on the bundle-product page is <bundle-product>,
        a different, pre-existing custom element) — so that constructor
        never fires at all, ever.

     Net effect: only the premature, unreliable attempt from (1) ever
     executed, which is why a manual refresh (different resource-cache
     timing on the repeat load) sometimes "fixed" it and sometimes didn't.
     Pulling the shared logic out to a standalone function — it never used
     `this` in the first place — and scheduling the 500ms retry directly
     (no custom element in between) means the retry actually runs every
     time, and removing the early, premature call site means it's the
     only one left. */
  /* Decodes the ?bundle= state written by bundle-atc-form.js. New URLs are
     UTF-8 base64 (so titles/characters like ’ – — œ never break it); bundles
     already in carts were plain Latin-1 base64, which is the fallback. */
  function decodeBundleState(param) {
    // A raw "+" in old, unencoded URLs comes back from URLSearchParams as a
    // space; base64 never contains spaces, so putting them back is safe.
    const binary = atob(param.replace(/ /g, '+'))
    try {
      const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))
      return JSON.parse(new TextDecoder('utf-8', { fatal: true }).decode(bytes))
    } catch (e) {
      return JSON.parse(binary)
    }
  }

  /* Keeps the custom frequency dropdown (trigger label + highlighted option)
     in step with the hidden <select> after its value is set from code. */
  function syncFrequencyDropdown(select) {
    const wrapper = select.closest('[data-bsw-frequency]')
    if (!wrapper) return
    const option = wrapper.querySelector(`[data-bsw-frequency-option][data-value="${select.value}"]`)
    const triggerLabel = wrapper.querySelector('[data-bsw-frequency-trigger-label]')
    if (!option) return
    if (triggerLabel) triggerLabel.textContent = option.dataset.triggerLabel || option.textContent.trim()
    wrapper.querySelectorAll('[data-bsw-frequency-option]').forEach(li => {
      li.setAttribute('aria-selected', li === option ? 'true' : 'false')
    })
  }

  async function restoreBundleStateFromURL() {
    // Check if the bundle state has been restored, if it has then exit early
    if (window.__bundleStateRestored) return false

    const bundleParam = new URLSearchParams(window.location.search).get('bundle')
    if (!bundleParam) return false

    window.__bundleStateRestored = true

    try {
      const state = decodeBundleState(bundleParam)

      // Set bundle type
      if (state.bundleTypeId) {
        const bundleTypeEl = document.querySelector(`[data-bundle-type="${state.bundleTypeId}"]`)
        if (bundleTypeEl) {
          bundleTypeEl.click()
        }
      }

      // Set subscription option
      if (state.subscription) {
        const subscriptionOption = document.querySelector('[data-bsw-subscription-option] input')
        if (subscriptionOption) {
          subscriptionOption.checked = true
          subscriptionOption.dispatchEvent(new Event('change'))
        }

        // Set selling plan (and show it in the custom dropdown too)
        if (state.sellingPlanId) {
          const sellingPlanSelect = document.querySelector('[data-bsw-selling-plan-select]')
          if (sellingPlanSelect) {
            sellingPlanSelect.value = state.sellingPlanId
            sellingPlanSelect.dispatchEvent(new Event('change'))
            syncFrequencyDropdown(sellingPlanSelect)
          }
        }
      }

      const isVisible = (el) => {
        const block = el.closest('[data-bundle-reference]')
        return !block || block.style.display !== 'none'
      }

      // Add items to bundle
      for (const item of (state.items || [])) {
        const quantity = parseInt(item.quantity, 10)
        if (!quantity || quantity < 1) continue

        /* Prefer the card in a visible block with the same collection the
           item was saved from, instead of the first match anywhere on the
           page (which could sit in a hidden block for another bundle type). */
        const candidates = [...document.querySelectorAll(`bundle-quantity-selector[data-bundle-option-id="${item.id}"]`)]
          .filter(el => el.dataset.isSummarySelector !== 'true')
        if (!candidates.length) continue

        const selector = candidates.find(el => isVisible(el) && (item.cid === undefined || (el.dataset.bundleOptionCid || '') === (item.cid || '')))
          || candidates.find(isVisible)
          || candidates[0]
        if (typeof selector.updateBundle !== 'function') continue

        /* Same path as a customer clicking "Add": shows the quantity
           controls AND the selected (white) styling, then syncs any other
           card for the same product. */
        selector.value = Math.min(quantity, selector.max || quantity)
        selector.input.value = selector.value
        selector.showSelectorValues()
        await selector.updateBundle()
        selector.syncProductCards()
      }

      return true
    } catch (e) {
      console.error('Failed to restore bundle state:', e)
      return false
    }
  }

  /**=================================================================
   * Bundle Quantity Selector
   * =================================================================
  */
  window.customElements.define('bundle-quantity-selector', class BundleQuantitySelector extends HTMLElement {
    constructor () {
      super()
      this.parser = new DOMParser()
      this.bundleList = document.querySelector('bundle-summary-items')
      this.bundleTypes = document.querySelectorAll('[data-bundle-type]')
      this.bundleOptions = document.querySelectorAll('[data-bundle-reference]')
      this.currentType = [...this.bundleTypes][0]

      this.addText = this.querySelector('[data-bqs-add-text]')
      this.input = this.querySelector('[data-bqs-input]')
      this.itemCID = this.getAttribute('data-bundle-option-cid')
      this.itemID = this.getAttribute('data-bundle-option-id')
      this.itemTitle = this.getAttribute('data-bundle-item-title')
      this.itemImage = this.getAttribute('data-bundle-item-image')
      this.itemPrice = this.getAttribute('data-bundle-quantity-selector')
      this.itemComparePrice = this.getAttribute('data-bundle-compare-at-price')
      this.itemSellingPlanIDs = this.getAttribute('data-bundle-selling-plan-ids')
      this.itemType = this.getAttribute('data-bundle-item-type')
      // Em: a DIY-type product (Shopify admin "Type" field, e.g. the
      // "KIIMA DIY lip balm mold") should make the plastic-savings
      // message read "infinite" instead of a count — this is the real
      // Shopify product.type, distinct from this.itemType above (the
      // theme's own applicator/refill/add-on block classification).
      this.itemProductType = this.getAttribute('data-bundle-item-product-type')
      this.itemMultiplier = this.getAttribute('data-bundle-item-multiplier') || '1'
      this.itemMax = this.input.getAttribute('max')
      this.add = this.querySelector('[data-bqs-add]')
      this.subtract = this.querySelector('[data-bqs-subtract]')
      this.value = 0
      this.max = parseInt(this.input.getAttribute('max'))
      this.matchingProductCards = this.findMatchingProductCards()
      // Em: "leave the products in order of appearence in the bundle
      // (exemple the applicator Bleu Glacier should be with the other
      // one at the top)" — the "My bundle" summary was ordering items
      // by whichever order the customer happened to click Add in, not
      // by where they sit in the actual bundle-builder grid (which
      // already groups Applicator / Refill / Add-on blocks together).
      // Stamp this card's own position among the real product-grid
      // selectors so a newly-added summary row can be inserted at the
      // matching spot instead of always appended to the end.
      this.orderIndex = this.computeOrderIndex()

      this.initTypeListeners()
      this.initQuantitySelector()
      this.initSubscriptionSelector()

      // Restoration now happens only via the standalone, directly-
      // scheduled 500ms-after-DOMContentLoaded retry further down this
      // file — see the restoreBundleStateFromURL comment above for why
      // this used to also fire from here, and why that was the bug.
    }

    computeOrderIndex () {
      // Only meaningful for a real product-card selector (not the
      // summary row's own <bundle-quantity-selector data-is-summary
      // -selector="true">, which returns -1 here and is never used for
      // ordering — the summary row's position is what's being set).
      const gridSelectors = [...document.querySelectorAll('bundle-quantity-selector')]
        .filter(selector => selector.dataset.isSummarySelector !== 'true')
      return gridSelectors.indexOf(this)
    }

    findMatchingProductCards () {
      const allSelectors = document.querySelectorAll('bundle-quantity-selector')
      return [...allSelectors].filter(selector => selector.dataset.bundleOptionId === this.itemID && selector.dataset.isSummarySelector !== 'true')
    }

    syncProductCards () {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')

        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            if (this.value > 0) {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'none'
              : 'flex'
            } else {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'flex'
              : 'none'
            }
          }
          matchingSelector.value = this.value
        }
      })
    }

    initSubscriptionSelector () {
      /* Em: with 1 refill, switching to Subscribe & save kept the button on
         "Add to my cart" (the 2-refill minimum wasn't checked). The check
         used to run on the option's click, a moment BEFORE the radio
         button is actually switched, so it still saw "one-time". It now
         runs on the radios' "change" event, which fires right after the
         switch, whether the customer clicks the circle, the text or
         anywhere on the option. */
      const purchaseOptionInputs = document.querySelectorAll(
        '[data-bsw-onetime-option] input, [data-bsw-subscription-option] input'
      )
      purchaseOptionInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateBundleSummary()
        })
      })
    }

    initTypeListeners () {
      this.updateBundleSummary()

      this.bundleTypes.forEach(type => {
        type.addEventListener('click', () => {
          if (this.dataset.isSummarySelector === 'true' || this.currentType === type) {
            this.currentType = type
            return
          }
          this.bundleTypes.forEach(bundleType => bundleType.classList.remove('selected'))
          type.classList.add('selected')

          this.currentType = type
          this.displayActiveOptions(type)
          this.updateSelectorsAndSummary()
          this.updateProductFormId()
          this.updateBundleSummary()
          this.updateSubscriptionWidget()
        })
      })
    }

    updateSubscriptionWidget () {
      const subscriptionOptions = document.querySelectorAll('[data-bundle-product-s-requirement]')
      const widgetOnetimeOption = document.querySelector('[data-bsw-onetime-option]')
      const widgetSubscriptionOption = document.querySelector('[data-bsw-subscription-option]')
      const currentType = document.querySelector('.bundle-product__header-option.selected')
      const defaultOption = document.querySelector('[data-bsw-default-option]')
      const nonSubscriptionProduct = [...subscriptionOptions].find(option => parseInt(option.dataset.bundleProductSRequirement) < 0)

      if (typeof nonSubscriptionProduct === 'undefined') { return }

      widgetSubscriptionOption.style.display = nonSubscriptionProduct.dataset.bundleReference === currentType.dataset.bundleType
        ? 'none'
        : 'block'

      if (typeof defaultOption !== 'undefined' && defaultOption !== null) {
        if (defaultOption.getAttribute('data-bsw-default-option') === 'one_time') {
          const thisInput = widgetOnetimeOption.querySelector('input')
          thisInput.checked = true
          return
        }
      }

      if (nonSubscriptionProduct.dataset.bundleReference === currentType.dataset.bundleType) {
        const thisInput = widgetOnetimeOption.querySelector('input')
        thisInput.checked = true
      } else {
        const thisInput = widgetSubscriptionOption.querySelector('input')
        thisInput.checked = true
      }
    }

    updateProductFormId () {
      const currentType = document.querySelector('.bundle-product__header-option.selected')
      const bundleVariantId = currentType.getAttribute('data-bundle-variant-id')
      const formProductInput = document.querySelector('[data-selected-bundle-type]')
      const formVariantSelect = document.querySelector('[data-bundle-variant-select]')

      formProductInput.setAttribute('data-selected-bundle-type-id', bundleVariantId)
      formVariantSelect.value = bundleVariantId
    }

    displayActiveOptions (selectedType) {
      this.bundleOptions.forEach(option => {
        option.style.display = option.getAttribute('data-bundle-reference') === selectedType.getAttribute('data-bundle-type')
          ? 'block'
          : 'none'
      })
    }

    updateSelectorsAndSummary () {
      const currentBundleItems = this.bundleList.querySelectorAll('bundle-item')
      const allProductCards = document.querySelectorAll('[data-bundle-product-card]')
      let visibleProductIds = []

      // Find all visible product cards
      allProductCards.forEach(card => {
        const parentOption = card.closest('.bundle-product__option')
        if (parentOption !== null && parentOption.style.display !== 'none') {
          visibleProductIds.push(card.getAttribute('data-bundle-product-card'))
        }
      })

      // Reset all selectors for products that are removed from the bundle summary
      currentBundleItems.forEach(item => {
        const itemId = item.getAttribute('data-bundle-item-id')
        const itemType = item.getAttribute('data-bundle-item-type')

        if (!visibleProductIds.includes(itemId) || itemType === '') {
          const allSelfInstances = [...allProductCards].filter(card => card.getAttribute('data-bundle-product-card') === itemId)
          for (let i = 0; i <  allSelfInstances.length; i++) {
            const selfSelector = allSelfInstances[i].querySelector('bundle-quantity-selector')

            for (let j = 0; j < selfSelector.children.length; j++) {
              selfSelector.children[j].style.display = selfSelector.children[j].hasAttribute('data-bqs-add-text')
                ? 'inline-flex'
                : 'none'
            }
          }
          item.remove()
        }
      })
    }

    hideSelectorValues () {
      // "Add" state (nothing selected yet) — see the matching class add in
      // showSelectorValues() below and the CSS that reads it, to make the
      // Add button read visually distinct from an already-selected item.
      this.classList.remove('bqs-has-value')

      if (this.dataset.isSummarySelector === 'true') {
        this.value = 0
        return
      }
      try {
        this.addText.style.display = 'flex'
        this.input.style.display = 'none'
        this.add.style.display = 'none'
        this.subtract.style.display = 'none'
        this.value = 0
      } catch (error) {
        console.log(error)
      }
    }

    showSelectorValues () {
      this.classList.add('bqs-has-value')

      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i]
        child.style.display = child.hasAttribute('data-bqs-add-text')
          ? 'none'
          : 'flex'
      }
    }

    initQuantitySelector () {
      this.add.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue + 1 <= this.max) {
            this.value = inputValue + 1
            this.input.value = this.value
            await this.updateBundle()
            this.syncProductCards()
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.subtract.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue - 1 > 0) {
            this.value = inputValue - 1
            this.input.value = this.value
            await this.updateBundle()
            this.syncProductCards()
          } else if (inputValue - 1 <= 0) {
            this.value = 0
            this.input.value = this.value
            this.removeFromBundle()
            this.hideSelectorValues()
            this.syncProductCards()
            this.updateBundleSummary()
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.input.addEventListener('change', async (e) => {
        const newValue = parseInt(e.target.value)

        if (typeof newValue === 'undefined' || isNaN(newValue)) {
          this.input.value = this.value
          return
        }

        if (newValue < 1) {
          this.value = 0
          this.input.value = this.value
          await this.updateBundle()
          this.hideSelectorValues()
          this.removeFromBundle()
        } else if (newValue <= this.max) {
          this.value = newValue
          this.input.value = this.value
          await this.updateBundle()
        } else if (newValue > this.max) {
          this.value = this.max
          this.input.value = this.value
          await this.updateBundle()
        }
        this.syncProductCards()
      })

      if (typeof this.addText !== 'undefined' && this.addText !== null) {
        this.addText.addEventListener('click', async () => {
          this.value = 1
          this.input.value = this.value
          this.showSelectorValues()
          await this.updateBundle()
          this.syncProductCards()
        })
      }
    }

    // updateCache () {
    //   const bundleItemsData = sessionStorage.getItem('bundleList')

    //   if (bundleItemsData === null || bundleItemsData === '') { return }

    //   const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')
    //   const thisVariant = bundleItemsJson.find(item => item.id === this.itemID)

    //   if (typeof thisVariant === 'undefined') { return }

    //   this.value = parseInt(thisVariant.quantity, 10)
    //   this.input.value = this.value
    // }

    async updateBundle () {
      const variant = this.searchForVariant(this.itemID)

      if (variant === null) { // Add as new bundle item
        if (this.classList.contains('manipulated')) {
          this.value = 1
        }
        const elementTemplate = this.bundleItemTemplate()
        const doc = this.parser.parseFromString(elementTemplate, 'text/html')
        const element = doc.querySelector('bundle-item')
        if (!element) { return }
        this.insertBundleItemInOrder(element)
      } else { // Update quantity
        const quantityInput = variant.querySelector('[data-bqs-input]')
        quantityInput.value = this.value
        quantityInput.setAttribute('value', this.value)
        this.input.value = this.value
      }

      await this.updateBundleSummary()
    }

    // Places a newly-added summary row where its product actually sits
    // in the bundle-builder grid (this.orderIndex), instead of always at
    // the end (previously always appendChild, so the row order was just
    // "whatever the customer clicked Add on, in that order" — Em wanted
    // it to match the grid grouping instead).
    insertBundleItemInOrder (element) {
      const newIndex = parseInt(element.dataset.orderIndex, 10)
      const existingItems = [...this.bundleList.children]
      const nextItem = existingItems.find(item => parseInt(item.dataset.orderIndex, 10) > newIndex)

      if (nextItem) {
        this.bundleList.insertBefore(element, nextItem)
      } else {
        this.bundleList.appendChild(element)
      }
    }
    
    // Updated Quantity - Francesco 
    async updateBundleSummary () {
      const bundleItems = document.querySelectorAll('bundle-item')
      const currentType = document.querySelector('.bundle-product__header-option.selected')

      if (typeof bundleItems === 'undefined' || bundleItems === null) { return }

      const bundleOptions = document.querySelectorAll('[data-bundle-product-type]')
      const activeOptions = [...bundleOptions].filter(option => option.dataset.bundleReference === currentType.dataset.bundleType)

      let applicatorORequirement, applicatorSRequirement, refillORequirement, refillSRequirement, applicatorCount, refillCount, addonCount, addonTotal, bundleTotal, bundleCompareTotal, refillTotal, applicatorTotal, plasticSavingsTotal
      applicatorORequirement = applicatorSRequirement = refillORequirement = refillSRequirement = applicatorCount = refillCount = addonCount = addonTotal = bundleTotal = bundleCompareTotal = refillTotal = applicatorTotal = plasticSavingsTotal = 0
      // Em: "if there is a DIY product, can you replace the number with
      // the word... infinite disposable lip balms" — tracked separately
      // from plasticSavingsTotal since a DIY mold's savings aren't a
      // real count.
      let bundleHasDIYItem = false

      const calculateRequirements = async () => {
        for (let i = 0; i < activeOptions.length; i++) {
          if (activeOptions[i].dataset.bundleProductType === 'applicator') {
            applicatorORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            applicatorSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          } else if (activeOptions[i].dataset.bundleProductType === 'refill') {
            refillORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            refillSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          }
        }
      }


      const calculateSummaryStats = async () => {
        bundleItems.forEach(item => {
          const quantitySelector = item.querySelector('[data-bqs-input]')
          const quantity = parseInt(quantitySelector.value)
          const productType = item.dataset.bundleItemType

          bundleTotal += parseInt(item.dataset.bundleItem) * quantity
          // No compare-at price on an item = use its price (was NaN, shown as "$0")
          const unitPrice = parseInt(item.dataset.bundleItem) || 0
          const unitCompareAt = parseInt(item.dataset.bundleItemCompareAt)
          bundleCompareTotal += (unitCompareAt > unitPrice ? unitCompareAt : unitPrice) * quantity
          if (productType === 'refill') {
            refillTotal += parseInt(item.dataset.bundleItem) * quantity
            // Items saved per refill is set per Bundle Options block (not
            // globally), so each item carries its own block's multiplier.
            plasticSavingsTotal += quantity * (parseFloat(item.dataset.bundleItemMultiplier) || 1)
          } else if (productType === 'applicator') {
            applicatorTotal += parseInt(item.dataset.bundleItem) * quantity
          } else if (productType === 'add-on') {
            addonTotal += parseInt(item.dataset.bundleItem) * quantity
          }


          if (item.dataset.bundleItemType === 'applicator') {
            applicatorCount += quantity
          } else if (item.dataset.bundleItemType === 'refill') {
            refillCount += quantity
          } else {
            addonCount += quantity
          }

          if ((item.dataset.bundleItemProductType || '').toLowerCase() === 'diy') {
            bundleHasDIYItem = true
          }
        })
      }

      const updateBundlePrices = async () => {
        const onetimePrice = document.querySelector('[data-bsw-onetime-price]')
        const onetimeComparePrice = document.querySelector('[data-bsw-onetime-compare-price]')
        const compareAtPrice = document.querySelector('[data-bsw-compare-at-price]')
        const discountedPrice = document.querySelector('[data-bsw-discounted-price]')
        const discountEntireBundleElement = document.querySelector('[data-bsw-discount-whole]')
        const discountEntireBundle = discountEntireBundleElement.getAttribute('data-bsw-discount-whole')
        const discountValue = parseInt(discountedPrice.getAttribute('data-bsw-discounted-price')) / 100
        const formattedMoney = Shopify.formatMoney(bundleTotal, theme.moneyFormat)
        const formattedCompareMoney = Shopify.formatMoney(bundleCompareTotal, theme.moneyFormat)

        if (discountEntireBundle === 'true') {
          const discounted = bundleTotal * (1.0 - discountValue)
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = applicatorCount + refillCount <= 0 && addonCount > 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
          discountedPrice.classList.toggle('bsw__price--discounted', refillTotal !== 0)
          } else {
          const discounted = (refillTotal * (1.0 - discountValue)) + applicatorTotal + addonTotal
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = refillTotal === 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
          discountedPrice.classList.toggle('bsw__price--discounted', refillTotal !== 0)
        }

        onetimePrice.textContent = formattedMoney
        compareAtPrice.textContent = formattedMoney

        if (onetimeComparePrice) {
          onetimeComparePrice.style.display = bundleCompareTotal <= bundleTotal
          ? 'none'
          : 'inline'
          onetimeComparePrice.textContent = formattedCompareMoney
        }
      }

      const updateButtonStates = async () => {
        const submitButton = document.querySelector('[data-bundle-submit]')
        const checkoutButton = document.querySelector('[data-bundle-checkout-submit]')
        const subscriptionPurchaseOption = document.querySelector('[data-bsw-subscription-option]')
        const subscriptionOptionInput = subscriptionPurchaseOption.querySelector('input')
        const buttonStates = document.querySelectorAll('[data-bundle-atc-button-state]')

        if (subscriptionOptionInput.checked) {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount < refillSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        } else {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount >= refillORequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount < refillORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        }

        // The "Go to checkout" button (optional) always mirrors the main
        // Add to cart button's enabled/disabled state rather than
        // duplicating every branch above.
        if (checkoutButton) {
          checkoutButton.disabled = submitButton.disabled
        }
      }

      const updatePlasticSavings = async () => {
        const savingsBar = document.querySelector('bundle-plastic-savings')
        if (!savingsBar) return

        const messageEl = savingsBar.querySelector('[data-bps-message]')

        // Only refills count toward containers saved — an applicator on
        // its own doesn't save anything. The multiplier (items saved per
        // refill) is set per Bundle Options block, not globally, since
        // different products pack a different number of single-use items
        // per refill — e.g. 2 for a lip balm refill, 1 for a deodorant
        // refill — so plasticSavingsTotal is already the sum of each
        // item's own quantity × its block's multiplier.
        const containersSaved = plasticSavingsTotal

        if (!bundleHasDIYItem && containersSaved <= 0) {
          savingsBar.style.display = 'none'
          return
        }

        const prefix = savingsBar.getAttribute('data-bps-prefix')
        const unitSingular = savingsBar.getAttribute('data-bps-unit-singular')
        const unitPlural = savingsBar.getAttribute('data-bps-unit-plural')

        if (bundleHasDIYItem) {
          // Em: a reusable DIY mold doesn't save a fixed number of
          // containers — shown regardless of the refill count above,
          // since the DIY item on its own is the whole point.
          const infiniteWord = savingsBar.getAttribute('data-bps-infinite-word') || 'infinite'
          messageEl.textContent = `${prefix} ${infiniteWord} ${unitPlural}`
        } else {
          const unit = containersSaved === 1 ? unitSingular : unitPlural
          messageEl.textContent = `${prefix} ${containersSaved} ${unit}`
        }
        savingsBar.style.display = 'block'
      }

      const updateMobileFAB = async () => {
        const mobileFAB = document.querySelector('mobile-bundle-fab')

        if (mobileFAB === null || typeof mobileFAB === 'undefined') { return }

        const productCountEl = mobileFAB.querySelector('[data-fab-products-quantity]')
        const productLabelEl = mobileFAB.querySelector('[data-fab-products-label]')
        const totalCount = applicatorCount + refillCount + addonCount
        productCountEl.textContent = totalCount

        if (productLabelEl) {
          productLabelEl.textContent = totalCount === 1
            ? productLabelEl.getAttribute('data-fab-label-singular')
            : productLabelEl.getAttribute('data-fab-label-plural')
        }

        if (typeof mobileFAB.setHasItems === 'function') {
          mobileFAB.setHasItems(totalCount > 0)
        }
      }

      // Run in order (".then(fn())" passed promises, not functions, so it only
      // worked because none of these await anything; errors were swallowed).
      await calculateRequirements()
      await calculateSummaryStats()
      await updateBundlePrices()
      await updateButtonStates()
      await updatePlasticSavings()
      await updateMobileFAB()
    }

    removeFromBundle () {
      const variant = this.searchForVariant(this.itemID)
      this.bundleList.removeChild(variant)
      // Update cache
        // const itemData = `{"id":"${this.itemID}","cid":"${this.itemCID}","quantity":"${this.value + 1}","sellingPlans":"${this.itemSellingPlanIDs}","title":"${this.itemTitle}","image":"${this.itemImage}","price":"${this.itemPrice}","type":"${this.itemType},"max":"${this.itemMax}"}`
        // const bundleItemsData = sessionStorage.getItem('bundleList')

        // const updatedData = bundleItemsData === null
        //   ? bundleItemsData.replace(itemData, '')
        //   : bundleItemsData.replace(itemData + ',', '')

        // sessionStorage.setItem('bundleList', updatedData)
    }

    searchForVariant (id) {
      return this.bundleList.querySelector(`[data-bundle-item-id="${id}"]`)
    }

    bundleItemTemplate (id = this.itemID, cid = this.itemCID, quantity = this.value, sellingPlans = this.itemSellingPlanIDs, title = this.itemTitle, image = this.itemImage, price = this.itemPrice, comparePrice = this.itemComparePrice, type = this.itemType, max = this.itemMax, multiplier = this.itemMultiplier, orderIndex = this.orderIndex, productType = this.itemProductType) {
      return `
        <bundle-item class="bundle-item"
          data-bundle-item="${price}"
          data-bundle-item-compare-at="${comparePrice}"
          data-bundle-item-collection-id="${cid}"
          data-bundle-item-id="${id}"
          data-bundle-item-selling-plan-ids="${sellingPlans}"
          data-bundle-item-type="${type}"
          data-bundle-item-product-type="${productType}"
          data-bundle-item-multiplier="${multiplier}"
          data-order-index="${orderIndex}"
        >
          <div class="bundle-item__image">
            ${`<img src="${image}&width=100" width="100" height="100" loading="lazy" alt="${title}">`}
          </div>

          <div class="bundle-item__content">
            <div class="bundle-item__link">
              <h4 class="bundle-item__title">${title}</h4>
            </div>

            <div class="bundle-item__quantity">
              <bundle-quantity-selector
                class="quantity-input"
                data-bundle-option-id="${id}"
                data-is-summary-selector="true"
              >
                <button
                  type="button"
                  class="quantity-input__button product__quantity-subtract-item"
                  data-bqs-subtract
                  aria-label="Minus"
                >

                <span class="icon icon-minus-small">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 10.75H.25v2.5H1.5v-2.5zm21 2.5h1.25v-2.5H22.5v2.5zm-21 0H12v-2.5H1.5v2.5zm10.5 0h10.5v-2.5H12v2.5z" fill="currentColor"/>
                  </svg>
                </span>

                </button>
                <label class="visually-hidden" for="Quantity-Input-${id}">Quantity</label>
                <input
                  type="number"
                  name="updates[]"
                  id="Quantity-Input-${id}"
                  value="${quantity}"
                  min="1"
                  max="${max}"
                  pattern="[0-9]*"
                  class="quantity-input__input"
                  data-bqs-input
                  aria-label="Quantity"
                />
                <button
                  type="button"
                  class="quantity-input__button product__quantity-add-item"
                  data-bqs-add
                  aria-label="Add"
                >

                  <span class="icon icon-plus-small">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.25 1.5V.25h-2.5V1.5h2.5zm-2.5 21v1.25h2.5V22.5h-2.5zM1.5 10.75H.25v2.5H1.5v-2.5zm21 2.5h1.25v-2.5H22.5v2.5zm-21 0H12v-2.5H1.5v2.5zm10.5 0h10.5v-2.5H12v2.5zM10.75 1.5V12h2.5V1.5h-2.5zm0 10.5v10.5h2.5V12h-2.5z" fill="currentColor"/>
                    </svg>
                  </span>
                </button>
              </bundle-quantity-selector>
            </div>

            <button class="bundle-item__remove" data-remove-bundle-item type="button" aria-label="Remove ${title} from your bundle">
              <span class="icon icon-plus-small">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.717 1.975 3.347.605.604 3.346l1.37 1.37 2.742-2.74zm14.566 20.05 1.37 1.37 2.742-2.741-1.37-1.37-2.742 2.74zm2.742-17.308 1.37-1.37L20.654.604l-1.37 1.37 2.74 2.742zM1.975 19.283l-1.37 1.37 2.741 2.742 1.37-1.37-2.74-2.742zm0-14.566 8.654 8.654 2.742-2.742-8.654-8.654-2.742 2.742zm11.396 8.654 8.654-8.654-2.742-2.742-8.654 8.654 2.742 2.742zm-2.742-2.742-8.654 8.654 2.742 2.741 8.654-8.653-2.742-2.742zm0 2.742 8.654 8.653 2.742-2.74-8.654-8.655-2.742 2.742z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          </div>
        </bundle-item>
      `
    }
  })

  /**=================================================================
   * Mobile Jump To Summary FAB
   * =================================================================
  */
  window.customElements.define('mobile-bundle-fab', class MobileBundleFAB extends HTMLElement {
    constructor () {
      super()

      this.topThreshold = document.querySelector('[data-bundle-fab-top]')
      this.bottomThreshold = document.querySelector('[data-bundle-fab-bottom]')

      if (typeof this.topThreshold === 'undefined' || this.topThreshold === null || typeof this.bottomThreshold === 'undefined' || this.bottomThreshold === null) { return }

      // Stays hidden until setHasItems(true) is called (once the first
      // product is added to the bundle) — see updateMobileFAB() below.
      this.hasItems = false

      this.initMobileFAB()
    }

    initMobileFAB () {
      function isInViewRange (upper, lower) {
        const upperRect = upper.getBoundingClientRect()
        const lowerRect = lower.getBoundingClientRect()
        const upperBound = window.innerHeight - upperRect.bottom
        const lowerBound = window.innerHeight - lowerRect.top

        return (upperBound > 0 && lowerBound < 0)
      }

      this.updateFABVisibility = () => {
        const visible = this.hasItems && isInViewRange(this.topThreshold, this.bottomThreshold)

        this.style.transform = visible ? 'translateY(0)' : 'translateY(100%)'
        this.style.opacity = visible ? '1' : '0'
      }

      window.addEventListener('scroll', () => this.updateFABVisibility())

      this.addEventListener('click', () => {
        this.bottomThreshold.scrollIntoView({ behavior: "smooth" })
      })
    }

    setHasItems (hasItems) {
      this.hasItems = hasItems
      if (typeof this.updateFABVisibility === 'function') this.updateFABVisibility()
    }
  })

  /**=================================================================
   * Bundle Summary Items
   * =================================================================
  */
  window.customElements.define('bundle-item', class BundleItem extends HTMLElement {
    constructor () {
      super()

      this.id = this.dataset.bundleItemId
      this.removeButton = this.querySelector('[data-remove-bundle-item]')
      this.quantitySelector = this.querySelector('bundle-quantity-selector')
      this.mainQuantitySelectors = document.querySelectorAll('[data-bundle-quantity-selector]')
      this.input = this.querySelector('[data-bqs-input]')
      this.add = this.querySelector('[data-bqs-add]')
      this.subtract = this.querySelector('[data-bqs-subtract]')
      this.max = parseInt(this.input.getAttribute('max'))
      this.matchingProductCards = this.findMatchingProductCards()
      this.matchingBundleSelectors = null

      this.initRemoveButton()
      this.initQuantitySelector()
    }

    updateQuantities () {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')
        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          matchingCard.classList.add('manipulated')
          // Em: removing an item via the bundle summary's trash button
          // (this method) left the product card's "Add" button white —
          // this class is what custom.css reads to paint it white while
          // selected (see showSelectorValues/hideSelectorValues on
          // BundleQuantitySelector, which do clear it on the other
          // removal paths); this one just never cleared it.
          matchingCard.classList.remove('bqs-has-value')
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
            ? 'flex'
            : 'none'
          }
        }
      })
    }

    initRemoveButton () {
      this.removeButton.addEventListener('click', (event) => {
        event.preventDefault()
        this.removeFromBundle()
      })
    }
    
    async updateBundleSummary () {
      const bundleItems = document.querySelectorAll('bundle-item')
      const currentType = document.querySelector('.bundle-product__header-option.selected')

      const bundleOptions = document.querySelectorAll('[data-bundle-product-type]')
      const activeOptions = [...bundleOptions].filter(option => option.dataset.bundleReference === currentType.dataset.bundleType)

      let applicatorORequirement, applicatorSRequirement, refillORequirement, refillSRequirement, applicatorCount, refillCount, addonCount, addonTotal, bundleTotal, bundleCompareTotal, refillTotal, applicatorTotal, plasticSavingsTotal
      applicatorORequirement = applicatorSRequirement = refillORequirement = refillSRequirement = applicatorCount = refillCount = addonCount = addonTotal = bundleTotal = bundleCompareTotal = refillTotal = applicatorTotal = plasticSavingsTotal = 0
      // Em: "if there is a DIY product, can you replace the number with
      // the word... infinite disposable lip balms" — tracked separately
      // from plasticSavingsTotal since a DIY mold's savings aren't a
      // real count.
      let bundleHasDIYItem = false

      const calculateRequirements = async () => {
        for (let i = 0; i < activeOptions.length; i++) {
          if (activeOptions[i].dataset.bundleProductType === 'applicator') {
            applicatorORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            applicatorSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          } else if (activeOptions[i].dataset.bundleProductType === 'refill') {
            refillORequirement += parseInt(activeOptions[i].dataset.bundleProductORequirement)
            refillSRequirement += parseInt(activeOptions[i].dataset.bundleProductSRequirement)
          }
        }
      }

      const calculateSummaryStats = async () => {
        bundleItems.forEach(item => {
          if (item.dataset.bundleItemId !== this.id) {
            const quantitySelector = item.querySelector('[data-bqs-input]')
            const quantity = parseInt(quantitySelector.value)
            const productType = item.dataset.bundleItemType

            bundleTotal += parseInt(item.dataset.bundleItem) * quantity
            // No compare-at price on an item = use its price (was NaN, shown as "$0")
            const unitPrice = parseInt(item.dataset.bundleItem) || 0
            const unitCompareAt = parseInt(item.dataset.bundleItemCompareAt)
            bundleCompareTotal += (unitCompareAt > unitPrice ? unitCompareAt : unitPrice) * quantity
            if (productType === 'refill') {
              refillTotal += parseInt(item.dataset.bundleItem) * quantity
              // Items saved per refill is set per Bundle Options block (not
              // globally), so each item carries its own block's multiplier.
              plasticSavingsTotal += quantity * (parseFloat(item.dataset.bundleItemMultiplier) || 1)
            } else if (productType === 'applicator') {
              applicatorTotal += parseInt(item.dataset.bundleItem) * quantity
            } else if (productType === 'add-on') {
              addonTotal += parseInt(item.dataset.bundleItem) * quantity
            }

            if (item.dataset.bundleItemType === 'applicator') {
              applicatorCount += quantity
            } else if (item.dataset.bundleItemType === 'refill') {
              refillCount += quantity
            } else {
              addonCount += quantity
            }

            if ((item.dataset.bundleItemProductType || '').toLowerCase() === 'diy') {
              bundleHasDIYItem = true
            }
          }
        })
      }

      const updateBundlePrices = async () => {
        const onetimePrice = document.querySelector('[data-bsw-onetime-price]')
        const onetimeComparePrice = document.querySelector('[data-bsw-onetime-compare-price]')
        const compareAtPrice = document.querySelector('[data-bsw-compare-at-price]')
        const discountedPrice = document.querySelector('[data-bsw-discounted-price]')
        const discountEntireBundleElement = document.querySelector('[data-bsw-discount-whole]')
        const discountEntireBundle = discountEntireBundleElement.getAttribute('data-bsw-discount-whole')
        const discountValue = parseInt(discountedPrice.getAttribute('data-bsw-discounted-price')) / 100
        const formattedMoney = Shopify.formatMoney(bundleTotal, theme.moneyFormat)
        const formattedCompareMoney = Shopify.formatMoney(bundleCompareTotal, theme.moneyFormat)
        if (discountEntireBundle === 'true') {
          const discounted = bundleTotal * (1.0 - discountValue)
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = applicatorCount + refillCount <= 0 && addonCount > 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
          discountedPrice.classList.toggle('bsw__price--discounted', refillTotal !== 0)
          } else {
          const discounted = (refillTotal * (1.0 - discountValue)) + applicatorTotal + addonTotal
          const discountedMoney = Shopify.formatMoney(discounted, theme.moneyFormat)
          discountedPrice.textContent = refillTotal === 0
            ? formattedMoney
            : discountedMoney
          compareAtPrice.style.display = refillTotal === 0
            ? 'none'
            : 'inline'
          discountedPrice.classList.toggle('bsw__price--discounted', refillTotal !== 0)
        }

        onetimePrice.textContent = formattedMoney
        compareAtPrice.textContent = formattedMoney
        if (onetimeComparePrice) {
          onetimeComparePrice.style.display = bundleCompareTotal <= bundleTotal
          ? 'none'
          : 'inline'
          onetimeComparePrice.textContent = formattedCompareMoney
        }
      }

      const updateButtonStates = async () => {
        const submitButton = document.querySelector('[data-bundle-submit]')
        const checkoutButton = document.querySelector('[data-bundle-checkout-submit]')
        const subscriptionPurchaseOption = document.querySelector('[data-bsw-subscription-option]')
        const subscriptionOptionInput = subscriptionPurchaseOption.querySelector('input')
        const buttonStates = document.querySelectorAll('[data-bundle-atc-button-state]')

        if (subscriptionOptionInput.checked) {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount >= refillSRequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorSRequirement && refillCount < refillSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorSRequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        } else {
          if (applicatorCount === 0 && refillCount === 0) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount >= refillORequirement) {
            submitButton.removeAttribute('disabled')
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'proceed')
            })
          } else if (applicatorCount >= applicatorORequirement && refillCount < refillORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-r')
            })
          } else if (applicatorCount < applicatorORequirement) {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-a')
            })
          } else {
            submitButton.setAttribute('disabled', true)
            buttonStates.forEach(state => {
              state.classList.toggle('visually-hidden', state.dataset.bundleAtcButtonState !== 'add-any')
            })
          }
        }

        // The "Go to checkout" button (optional) always mirrors the main
        // Add to cart button's enabled/disabled state rather than
        // duplicating every branch above.
        if (checkoutButton) {
          checkoutButton.disabled = submitButton.disabled
        }
      }

      const updatePlasticSavings = async () => {
        const savingsBar = document.querySelector('bundle-plastic-savings')
        if (!savingsBar) return

        const messageEl = savingsBar.querySelector('[data-bps-message]')

        // Only refills count toward containers saved — an applicator on
        // its own doesn't save anything. The multiplier (items saved per
        // refill) is set per Bundle Options block, not globally, since
        // different products pack a different number of single-use items
        // per refill — e.g. 2 for a lip balm refill, 1 for a deodorant
        // refill — so plasticSavingsTotal is already the sum of each
        // item's own quantity × its block's multiplier.
        const containersSaved = plasticSavingsTotal

        if (!bundleHasDIYItem && containersSaved <= 0) {
          savingsBar.style.display = 'none'
          return
        }

        const prefix = savingsBar.getAttribute('data-bps-prefix')
        const unitSingular = savingsBar.getAttribute('data-bps-unit-singular')
        const unitPlural = savingsBar.getAttribute('data-bps-unit-plural')

        if (bundleHasDIYItem) {
          // Em: a reusable DIY mold doesn't save a fixed number of
          // containers — shown regardless of the refill count above,
          // since the DIY item on its own is the whole point.
          const infiniteWord = savingsBar.getAttribute('data-bps-infinite-word') || 'infinite'
          messageEl.textContent = `${prefix} ${infiniteWord} ${unitPlural}`
        } else {
          const unit = containersSaved === 1 ? unitSingular : unitPlural
          messageEl.textContent = `${prefix} ${containersSaved} ${unit}`
        }
        savingsBar.style.display = 'block'
      }

      const updateMobileFAB = async () => {
        const mobileFAB = document.querySelector('mobile-bundle-fab')

        if (mobileFAB === null || typeof mobileFAB === 'undefined') { return }

        const productCountEl = mobileFAB.querySelector('[data-fab-products-quantity]')
        const productLabelEl = mobileFAB.querySelector('[data-fab-products-label]')
        const totalCount = applicatorCount + refillCount + addonCount
        productCountEl.textContent = totalCount

        if (productLabelEl) {
          productLabelEl.textContent = totalCount === 1
            ? productLabelEl.getAttribute('data-fab-label-singular')
            : productLabelEl.getAttribute('data-fab-label-plural')
        }

        if (typeof mobileFAB.setHasItems === 'function') {
          mobileFAB.setHasItems(totalCount > 0)
        }
      }

      // Run in order (".then(fn())" passed promises, not functions, so it only
      // worked because none of these await anything; errors were swallowed).
      await calculateRequirements()
      await calculateSummaryStats()
      await updateBundlePrices()
      await updateButtonStates()
      await updatePlasticSavings()
      await updateMobileFAB()
    }
    
    async removeFromBundle () {
      // const bundleItemsData = sessionStorage.getItem('bundleList')
      // const bundleItemsJson = JSON.parse('[' + bundleItemsData + ']')
      // const bundleItemsWithoutMe = bundleItemsJson.filter(item => item.id !== this.id)
      // const bundleItemsStr = JSON.stringify(bundleItemsWithoutMe)
      // const bundleItemFormatted = bundleItemsStr.substring(1, bundleItemsStr.length-1)
      // sessionStorage.setItem('bundleList', bundleItemFormatted)
      this.updateQuantities()
      this.updateBundleSummary()
      this.remove()
    }

    findMatchingProductCards () {
      this.allSelectors = document.querySelectorAll('bundle-quantity-selector')
      return [...this.allSelectors].filter(selector => selector.dataset.bundleOptionId === this.id && selector.dataset.isSummarySelector !== 'true')
    }

    updateProductCards (newValue) {
      if (this.matchingProductCards === null || typeof this.matchingProductCards === 'undefined') { return }

      this.matchingProductCards.forEach(matchingCard => {
        const matchingSelector = matchingCard.querySelector('[data-bqs-input]')

        if (typeof matchingSelector !== 'undefined' && matchingSelector !== null) {
          for (let i = 0; i < matchingCard.children.length; i++) {
            const child = matchingCard.children[i]
            if (newValue > 0) {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'none'
              : 'flex'
            } else {
              child.style.display = child.nodeName === 'SPAN' || child.nodeName === 'span'
              ? 'flex'
              : 'none'
            }
          }
          // Same white-button class as updateQuantities() above — keep it
          // set while the summary still has a quantity for this item,
          // clear it once the summary quantity is dropped to 0 here too.
          matchingCard.classList.toggle('bqs-has-value', newValue > 0)
          matchingSelector.value = newValue
        }
      })
    }

    initQuantitySelector () {
      this.add.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue + 1 <= this.max) {
            this.updateProductCards(inputValue + 1)
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.subtract.addEventListener('click', async () => {
        try {
          const inputValue = parseInt(this.input.value)
          if (inputValue - 1 > 0) {
            this.updateProductCards(inputValue - 1)
          } else {
            this.updateProductCards(0)
          }
        } catch (error) {
          console.log(error)
        }
      })

      this.input.addEventListener('change', async (e) => {
        const newValue = parseInt(e.target.value)
        if (newValue < 1) {
          await this.removeFromBundle()
        }
        this.updateProductCards(newValue)
      })
    }
    
  })

  /* Schedules the reliably-timed restoreBundleStateFromURL retry directly,
     500ms after DOMContentLoaded — NOT gated behind a custom element
     anymore. It used to live in a <bundle-product-container> custom
     element's constructor (window.customElements.define('bundle-product-container', ...)),
     on the theory that its constructor firing would be a reliable "DOM is
     ready" signal. That element tag is never actually present in any
     template (the real wrapper on the bundle-product page is
     <bundle-product>, a different, pre-existing custom element defined
     elsewhere) — so that constructor never ran, and this retry never
     fired at all, before or after the this.restoreBundleStateFromURL()
     bugfix. Net effect of that fix alone: the early, unreliable call site
     was removed and nothing replaced it, so the bundle stopped restoring
     even on refresh (Em: "page blanche, si je refresh il n'y a aucun
     produit dans le bundle"). Scheduling the retry directly here, with no
     dependency on any custom element existing, actually runs it. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => restoreBundleStateFromURL(), 500)
    })
  } else {
    setTimeout(() => restoreBundleStateFromURL(), 500)
  }

  // remove items from cart

  /* Refreshes the full /cart page's own item list + subtotal after a
     bundle action (remove, or the subscribe-toggle below) — needed
     because apps:product-added-to-cart only refreshes the quick-cart
     drawer (assets/theme.js's register("quick-cart", ...)); the drawer
     and the full cart page section both render on /cart (the drawer as
     a global overlay section), and only the drawer's own listener picks
     that event up. The full cart page's "cart" component instead
     listens on an internal pub-sub event theme.js never exposes outside
     its own closure, so there's no way to trigger its existing
     refreshCart() from here — this does the same section_id re-fetch +
     innerHTML swap it does, directly. No-ops harmlessly when the full
     cart page isn't in the DOM (e.g. inside the quick-cart drawer on any
     other page). */
  const refreshMainCartPage = async () => {
    const cartSection = document.querySelector('[data-section-type="cart"]')
    if (!cartSection) return
    const sectionId = cartSection.dataset.sectionId
    if (!sectionId) return
    try {
      const res = await fetch("".concat(window.location.pathname, "?section_id=").concat(sectionId))
      if (!res.ok) return
      const html = await res.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const sourceItems = doc.querySelector('[js-cart-items]')
      const targetItems = cartSection.querySelector('[js-cart-items]')

      // Em: removing the last item (a bundle) left the old cart on screen
      // ("3 items", subtotal, checkout buttons). When the cart is now
      // empty, show the empty-cart page instead, like the theme does.
      if (!sourceItems || !targetItems) {
        const sourceSection = doc.querySelector('[data-section-type="cart"]')
        if (sourceSection) cartSection.innerHTML = sourceSection.innerHTML
        return
      }

      // Keep the "Add more products" block that's already on the page (its
      // buttons and slider are already set up by the theme); the copy in
      // the fresh HTML would come without them.
      const currentCrossSells = targetItems.querySelector('[data-cross-sells]')
      targetItems.innerHTML = sourceItems.innerHTML
      const freshCrossSells = targetItems.querySelector('[data-cross-sells]')
      if (currentCrossSells && freshCrossSells) freshCrossSells.replaceWith(currentCrossSells)

      const sourceSubtotal = doc.querySelector('[js-cart-footer-subtotal-wrapper]')
      const targetSubtotal = cartSection.querySelector('[js-cart-footer-subtotal-wrapper]')
      if (sourceSubtotal && targetSubtotal) targetSubtotal.outerHTML = sourceSubtotal.outerHTML

      // Em: the free shipping bar kept the old amount after removing a
      // bundle — update it with the new cart total too.
      const sourceBar = doc.querySelector('[data-free-shipping-bar]')
      const targetBar = cartSection.querySelector('[data-free-shipping-bar]')
      if (sourceBar && targetBar && window.kiimaRenderFreeShippingBar) {
        targetBar.dataset.cartTotal = sourceBar.dataset.cartTotal
        window.kiimaRenderFreeShippingBar(targetBar)
      }
    } catch (err) {
      console.error('Error refreshing cart page:', err)
    }
  }

  // const removeBundlesFromCart = document.querySelectorAll('[data-remove-bundle-items]');

  // removeBundlesFromCart.forEach(button => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-remove-bundle-items]');
      if (!button) return;

      const bundleGroup = button.closest('[data-id]');
      const bundleId = bundleGroup?.getAttribute('data-id');
      if (!bundleId) return;

      try {
        const cartData = await fetch('/cart.js').then(res => res.json());
        const updates = {};
    
        cartData.items.forEach(item => {
          if (item.properties && item.properties._bundle_state_url === bundleId && item.key) {
            updates[item.key] = 0;
    
            if (typeof window.cart?.updateItem === 'function') {
              window.cart.updateItem(item.key, 0);
            }
          }
        });
    
        // If no cart.updateItem, fallback to cart/update.js
        if (typeof window.cart?.updateItem !== 'function' && Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
    
        // Remove group DOM node immediately
        if (bundleGroup) bundleGroup.remove();
    
        // Force cart refresh – always reliable
        if (window.fluorescent?.Cart?.fetchAndRender) {
          await window.fluorescent.Cart.fetchAndRender();
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
    
        // Re-dispatch with unique detail
        const event = new CustomEvent('apps:product-added-to-cart', {
          detail: { timestamp: Date.now() }
        });
        document.dispatchEvent(event);

        // Refreshes the full /cart page's own list too — see
        // refreshMainCartPage above for why this is needed alongside the
        // event above.
        await refreshMainCartPage();

      } catch (err) {
        console.error('Error removing bundle:', err);
      }
    });
  // });



})();

/* -------- FREE SHIPPING BAR: MARKET-CURRENCY OVERRIDE CORRECTION --------
   theme.js's own freeShippingBar() (assets/theme.js) always multiplies
   the threshold by window.Shopify.currency.rate, assuming the value it's
   given is in the shop's base/reporting currency. The per-market
   metafield override in snippets/free-shipping-bar.liquid is
   deliberately already in that market's own local currency instead (so
   "100" for the US market always means $100 USD, not a value that
   drifts with the live exchange rate) — flagged with
   data-threshold-is-local-currency="true". theme.js's version double-
   converts that value, so this recomputes the bar correctly right after
   theme.js runs, using the same Shopify.formatMoney/theme.moneyFormat
   helpers used elsewhere in this file. Deliberately NOT a patch to
   theme.js itself — that's a vendor-bundled file overwritten on theme
   updates. The global (non-market) fallback threshold is untouched and
   keeps behaving exactly as it always has. */
;(() => {
  const barSelector = '[data-free-shipping-bar][data-threshold-is-local-currency="true"]'

  const correctBar = (node) => {
    const threshold = parseInt(node.dataset.threshold, 10)
    const cartTotal = parseInt(node.dataset.cartTotal, 10)
    if (isNaN(threshold) || isNaN(cartTotal) || threshold <= 0) return

    const progressBar = node.querySelector('.free-shipping-bar__bar')
    const message = node.querySelector('.free-shipping-bar__message')
    if (!progressBar || !message) return

    const thresholdInCents = threshold * 100
    const progress = cartTotal < thresholdInCents ? (cartTotal / thresholdInCents) * 100 : 100
    const expectedWidth = progress + '%'

    // Already correct — skip the write entirely. This is what stops our
    // own style/class writes below from re-triggering the attribute
    // observer in init() and looping forever; it also makes repeated
    // calls (from bursts of mutations) cheap no-ops.
    if (progressBar.style.getPropertyValue('--progress-width') === expectedWidth) return

    if (cartTotal >= thresholdInCents) {
      node.classList.add('free-shipping-bar--success')
      message.innerText = node.dataset.freeShippingSuccessMessage
    } else {
      const remainder = Math.abs(cartTotal - thresholdInCents)
      const formatted = (window.Shopify && window.Shopify.formatMoney)
        ? window.Shopify.formatMoney(remainder, window.theme && window.theme.moneyFormat)
        : '$' + (remainder / 100).toFixed(2)
      message.innerHTML = (node.dataset.freeShippingPendingMessage || '').replace(
        '{{ remaining_amount }}',
        '<span class="fs-body-bold">' + formatted + '</span>'
      )
      node.classList.remove('free-shipping-bar--success')
    }

    progressBar.style.setProperty('--progress-width', expectedWidth)
    node.classList.add('free-shipping-bar--loaded')
  }

  const correctAll = () => {
    document.querySelectorAll(barSelector).forEach(correctBar)
  }

  const init = () => {
    correctAll()

    // theme.js's own freeShippingBar() (assets/theme.js) doesn't only run
    // once at page load — its component-loading system can run it again
    // later on the SAME already-present node (not just on freshly-inserted
    // AJAX markup), each time re-writing the wrong --progress-width/message
    // right back on top of our fix. Watching both new-node insertion
    // (childList) and style/class changes on existing nodes (attributes)
    // catches every case regardless of when/how theme.js re-runs; the
    // "already correct" early-return in correctBar above is what stops
    // that attribute watch from looping on our own writes.
    let scheduled = false
    const observer = new MutationObserver(() => {
      if (scheduled) return
      scheduled = true
      window.requestAnimationFrame(() => {
        scheduled = false
        correctAll()
      })
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()

/* -------- QUICK CART: UPSELL AS ITS OWN STEP --------
   sections/quick-cart.liquid now renders the cross-sells block into a
   separate, hidden .quick-cart__upsell-step panel instead of inline at
   the bottom of the item list. This intercepts the first click on
   "Checkout": instead of submitting, it swaps .quick-cart__items out for
   that panel and relabels the button to "No thanks". A second click (now
   labelled "No thanks") submits for real and proceeds to checkout —
   whatever the shopper added from the upsell panel in the meantime is
   already in the cart, since adding to cart is a normal AJAX call, not
   part of this form's own submit.

   Delegated on document (not queried once at load) because the form
   itself is static markup already in the DOM at load — no need to
   re-bind after theme.js's AJAX cart refresh, which only ever replaces
   .quick-cart__items's innerHTML, never this form/button/panel. */
;(() => {
  const resetStep = (form) => {
    const items = form.querySelector('.quick-cart__items')
    const upsellStep = form.querySelector('[data-quick-cart-upsell-step]')
    const button = form.querySelector('[data-quick-cart-checkout]')
    if (items) items.classList.remove('quick-cart__view-hidden')
    if (upsellStep) {
      upsellStep.classList.add('quick-cart__view-hidden')
      upsellStep.classList.remove('quick-cart__step-enter')
    }
    if (button) {
      button.dataset.quickCartStep = 'cart'
      button.textContent = button.dataset.checkoutLabel || button.textContent
    }
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.quick-cart__close-icon, .quick-cart__overlay')) return
    document.querySelectorAll('.quick-cart__form').forEach(resetStep)
  })

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.quick-cart__form')
    if (!form) return

    const button = e.submitter
    if (!button || !button.hasAttribute('data-quick-cart-checkout')) return

    // Already on the upsell step ("No thanks" showing) — let it submit
    // for real this time.
    if (button.dataset.quickCartStep === 'upsell') return

    const upsellStep = form.querySelector('[data-quick-cart-upsell-step]')
    // No cross-sells block at all (setting off), or nothing eligible to
    // show (cross-sells.liquid renders empty in that case) — nothing to
    // offer, so go straight to checkout like before.
    if (!upsellStep || !upsellStep.querySelector('[data-cross-sells]')) return

    e.preventDefault()
    const items = form.querySelector('.quick-cart__items')
    if (items) items.classList.add('quick-cart__view-hidden')

    // Scroll-bug fix: .quick-cart__footer is docked absolutely over the
    // bottom of the drawer at all times. theme.js compensates for this
    // on .quick-cart__items via adjustItemPadding() (padding-bottom =
    // footer height) but never on this panel — without the same
    // padding here the bottom of the list has nowhere to scroll to and
    // stays hidden behind the footer.
    const footer = form.querySelector('.quick-cart__footer')
    if (footer) {
      upsellStep.style.paddingBottom = "".concat(footer.getBoundingClientRect().height, "px")
    }

    // Mini transition into the upsell step (Em: "faire un mini
    // transition vers la section upselling"). Reveal it in its
    // pre-transition state, force a reflow so the browser registers
    // that starting state, then remove it — the transition declared on
    // .quick-cart__upsell-step in custom.css animates the rest.
    upsellStep.classList.remove('quick-cart__view-hidden')
    upsellStep.classList.add('quick-cart__step-enter')
    void upsellStep.offsetWidth
    upsellStep.classList.remove('quick-cart__step-enter')

    button.dataset.quickCartStep = 'upsell'
    button.textContent = button.dataset.noThanksLabel || button.textContent
    form.scrollTop = 0
  })
})()

/* -------- QUICK CART: UPSELL STEP "ADD" — FIX STUCK LOADING + ITEM NOT DISAPPEARING --------
   theme.js's built-in cross-sells button (assets/theme.js's
   CrossSells()) adds a 'loading' class on click and relies entirely on
   quick-cart's AJAX refresh to re-render the cross-sells markup fresh
   from the server — that's what used to clear the class and drop the
   now-in-cart product from the list. That refresh
   (theme.js's refreshQuickCart) only ever replaces the innerHTML of
   .quick-cart__items — now that this panel lives in its own
   .quick-cart__upsell-step sibling (see the "upsell as its own step"
   block above), refreshQuickCart never touches it, so the 'loading'
   class never clears (reads as loading forever — Em: "ça load à
   l'infini") and the item never disappears (Em: "le produit devrait
   concrêtement disparaitre").

   This intercepts the click in the capture phase — before theme.js's
   own listener runs — does the add itself (same /cart/add.js call
   assets/bundle-atc-form.js and the subscribe-toggle below already
   use), removes the item from view directly on success, and dispatches
   apps:product-added-to-cart, the one real DOM event theme.js listens
   for to refresh the rest of the quick cart (item count, subtotal,
   regular item list). stopImmediatePropagation keeps theme.js's own
   handler on the same click from also firing and adding the item
   twice. Scoped to .quick-cart__upsell-step, so cross-sells elsewhere
   (the /cart page, product quick-view) keep using theme.js's native
   behavior untouched. */
;(() => {
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.quick-cart__upsell-step [data-add-item-id]')
    if (!button || button.classList.contains('loading')) return

    e.preventDefault()
    e.stopImmediatePropagation()

    const { addItemId } = button.dataset
    if (!addItemId) return

    const item = button.closest('.cross-sells__item')
    button.classList.add('loading')

    fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: addItemId, quantity: 1 }] })
    })
      .then((res) => {
        if (!res.ok) throw new Error('Add to cart failed')
        if (item) item.remove()
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'))
      })
      .catch((err) => {
        console.error('Error adding cross-sell item:', err)
        button.classList.remove('loading')
      })
  }, true)
})()

/* -------- QUICK CART: "SUBSCRIBE & SAVE" TOGGLE FOR ONE-TIME BUNDLES --------
   sections/quick-cart.liquid renders this button only for items in the
   bundle group that have a matching 3-month selling plan, with the exact
   remove-then-re-add payload (variant id, quantity, selling_plan id, and
   the item's own properties — including _bundle_state_url, so the
   converted lines still group into the same bundle card) already baked
   into data-bundle-subscribe-items as JSON. Shopify's cart has no
   "change an existing line's selling plan" endpoint, so this removes
   the one-time lines via /cart/update.js and re-adds them via
   /cart/add.js with the plan attached — the same two-step pattern
   assets/bundle-atc-form.js already uses when editing a bundle (and
   uses the same plain /cart/add.js path — no window.Shopify.routes.root
   prefix — as /cart/update.js just above it here; both are locale-
   agnostic Shopify AJAX cart endpoints, so there's no reason for the two
   calls in this one flow to build their URL two different ways).
   Dispatching apps:product-added-to-cart afterwards is what makes
   theme.js re-fetch and re-render the quick cart, which is what
   actually swaps this button out for the normal
   .quick-cart__bundle-subscription-note pill (has_subscription is now
   true server-side) — there's no separate "success" step to write here.

   Em reported the refill line(s) disappearing entirely from the bundle
   after clicking this — the add-with-selling_plan call is failing
   server-side (a plan/variant mismatch, most likely, but unconfirmed),
   and neither fetch here originally checked its response status, so
   that failure was silently treated as success: the one-time lines were
   already removed by the update.js call above, and nothing came back to
   replace them. This now checks both responses, rolls the removed lines
   back to one-time if the subscription add fails, and — since the exact
   reason for that failure isn't visible from code alone — surfaces
   whatever Shopify actually returned as a small red line under the
   button (and to the console) rather than only failing silently, so the
   real cause shows up directly in a screenshot instead of guesswork. */
;(() => {
  /* Shopify's error on the actual add attempt was "expected Array to be
     a Hash: properties". Root cause: Liquid's `| json` filter on
     item.properties doesn't serialize it as a plain object — it follows
     item.properties' own {% for %}-iteration shape, an array of
     [key, value] pairs (e.g. [["_bundle_state_url","..."],["_key",
     "..."]]) — even when it's non-empty, so /cart/add.js rejects it
     outright. An earlier version of this fix just discarded any
     array-shaped properties down to {}, which stopped the rejection but
     also silently wiped out _bundle_state_url/_bundle_item/_key on every
     converted line — the lines still got added (now on the right
     selling plan), just no longer grouped into the bundle card, because
     the property that groups them was gone. This rebuilds the real
     object from those pairs instead of throwing the data away. */
  const normalizeProperties = (properties) => {
    if (!properties) return {}
    if (Array.isArray(properties)) {
      return properties.reduce((acc, pair) => {
        if (Array.isArray(pair) && pair.length === 2) acc[pair[0]] = pair[1]
        return acc
      }, {})
    }
    return properties
  }

  /* Same helper as the bundle-remove handler above (separate IIFE, so
     duplicated rather than shared) — refreshes the full /cart page's own
     item list + subtotal, since apps:product-added-to-cart only reaches
     the quick-cart drawer. No-ops when the full cart page isn't in the
     DOM. */
  const refreshMainCartPage = async () => {
    const cartSection = document.querySelector('[data-section-type="cart"]')
    if (!cartSection) return
    const sectionId = cartSection.dataset.sectionId
    if (!sectionId) return
    try {
      const res = await fetch("".concat(window.location.pathname, "?section_id=").concat(sectionId))
      if (!res.ok) return
      const html = await res.text()
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const sourceItems = doc.querySelector('[js-cart-items]')
      const targetItems = cartSection.querySelector('[js-cart-items]')

      // Em: removing the last item (a bundle) left the old cart on screen
      // ("3 items", subtotal, checkout buttons). When the cart is now
      // empty, show the empty-cart page instead, like the theme does.
      if (!sourceItems || !targetItems) {
        const sourceSection = doc.querySelector('[data-section-type="cart"]')
        if (sourceSection) cartSection.innerHTML = sourceSection.innerHTML
        return
      }

      // Keep the "Add more products" block that's already on the page (its
      // buttons and slider are already set up by the theme); the copy in
      // the fresh HTML would come without them.
      const currentCrossSells = targetItems.querySelector('[data-cross-sells]')
      targetItems.innerHTML = sourceItems.innerHTML
      const freshCrossSells = targetItems.querySelector('[data-cross-sells]')
      if (currentCrossSells && freshCrossSells) freshCrossSells.replaceWith(currentCrossSells)

      const sourceSubtotal = doc.querySelector('[js-cart-footer-subtotal-wrapper]')
      const targetSubtotal = cartSection.querySelector('[js-cart-footer-subtotal-wrapper]')
      if (sourceSubtotal && targetSubtotal) targetSubtotal.outerHTML = sourceSubtotal.outerHTML

      // Em: the free shipping bar kept the old amount after removing a
      // bundle — update it with the new cart total too.
      const sourceBar = doc.querySelector('[data-free-shipping-bar]')
      const targetBar = cartSection.querySelector('[data-free-shipping-bar]')
      if (sourceBar && targetBar && window.kiimaRenderFreeShippingBar) {
        targetBar.dataset.cartTotal = sourceBar.dataset.cartTotal
        window.kiimaRenderFreeShippingBar(targetBar)
      }
    } catch (err) {
      console.error('Error refreshing cart page:', err)
    }
  }

  const clearError = (button) => {
    const existing = button.parentElement?.querySelector('.quick-cart__bundle-subscribe-error')
    if (existing) existing.remove()
  }

  const showError = (button, message) => {
    clearError(button)
    const el = document.createElement('p')
    el.className = 'quick-cart__bundle-subscribe-error fs-body-50'
    el.textContent = message
    button.insertAdjacentElement('afterend', el)
  }

  const readErrorMessage = async (res) => {
    try {
      const data = await res.json()
      return data.description || data.message || JSON.stringify(data)
    } catch (err) {
      return "".concat(res.status, " ").concat(res.statusText)
    }
  }

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-bundle-subscribe-toggle]')
    if (!button || button.classList.contains('loading')) return

    let items
    try {
      items = JSON.parse(button.dataset.bundleSubscribeItems)
    } catch (err) {
      console.error('Could not parse bundle subscribe items:', err)
      return
    }
    if (!Array.isArray(items) || !items.length) return

    clearError(button)
    button.classList.add('loading')

    /* Em: "I don't like the effect of toggle flashing. Can you just make
       the whole block fade until the pill appear?" — starts the fade
       right away, at the same time as the network calls below, instead
       of only after they succeed. The switch itself no longer changes
       appearance on click at all (see custom.css) — this fade is the
       only feedback now, and it's already most of the way through by
       the time the real content is ready to swap in.

       Em: "when i click on the toggle, the whole quick-cart__bundle-
       group-information disappear, I only wanted the quick-cart
       __bundle-subscribe-panel to disappear" — this used to fade
       [data-input-item] (the ENTIRE card: image, title, price, item
       list, the toggle pill, everything). Scoped down to just the
       panel (the toggle pill + perks checklist together) now — not the
       rest of the card above it, and not just the perks list alone. */
    const card = button.closest('.quick-cart__bundle-subscribe-panel')
    /* Em: "make the panel [fade] after the toggle has done it's
       movement" / "more please, the toggle has no time to finish its
       movement" — a short pause before the panel starts fading, so the
       toggle's own feedback (previously a sliding knob; now the
       checkbox's checkmark appearing, see .loading above and
       custom.css) is visible for a beat before everything fades away
       instead of getting cut off. */
    let cardFadeTimeout = null
    if (card) {
      cardFadeTimeout = setTimeout(() => {
        card.classList.add('bundle-subscribe-transitioning')
        /* Em: "the card does not fade out" — set directly as inline
           styles too, not just via the class above. Inline styles
           always win over a stylesheet rule regardless of any selector
           specificity/order elsewhere in custom.css or theme.css, so
           this guarantees the fade actually happens instead of
           silently losing to some other rule touching this same card.
           Belt-and-braces with the class, which stays for anything
           else that wants to key off it. */
        card.style.transition = 'opacity 250ms ease, transform 250ms ease'
        card.style.opacity = '0'
        card.style.transform = 'scale(0.98)'
      }, 400)
    }

    const oneTimePayload = items.map(item => ({
      id: item.id,
      quantity: item.quantity,
      properties: normalizeProperties(item.properties)
    }))

    try {
      const updates = {}
      items.forEach(item => { updates[item.key] = 0 })
      const addPayload = {
        items: items.map(item => ({
          id: item.id,
          quantity: item.quantity,
          selling_plan: item.selling_plan,
          properties: normalizeProperties(item.properties)
        }))
      }

      /* Em: "there is a 3s delay before the blue pill of confirmation
         arrives, can you make it quicker" — these two calls were
         previously awaited one after the other, so the customer waited
         for two full network round-trips back to back. They don't
         actually depend on each other: the add below creates a distinct
         cart line (a different id+selling_plan combination), independent
         of the one-time line being zeroed out here — so firing both at
         once and waiting on whichever is slower, instead of summing
         both, roughly halves this part of the wait. */
      const [removeRes, addRes] = await Promise.all([
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }),
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload)
        })
      ])

      if (removeRes.ok && addRes.ok) {
        /* Em: "added items without subscription, clicked Subscribe, the
           refills duplicated in the cart (but Edit shows them correctly,
           not duplicated)" — both requests above report success
           individually, but they're two separate concurrent writes to
           the SAME cart. Shopify's cart isn't locked between them: if
           add.js's own read-modify-write of the cart happens to land
           around the same time as update.js's, one write can be based
           on a cart snapshot taken before the other's change landed,
           and silently overwrite it when it saves — so the one-time
           lines we just told update.js to zero out can come back once
           add.js's write lands after it. (Edit reads the bundle's
           contents from its own ?bundle= state, not from these cart
           lines, which is why it never showed the duplicate.)

           Re-check the real cart after both calls settle and, if any of
           the lines we asked to remove are still sitting at a nonzero
           quantity, remove them again. This keeps the parallel speed-up
           above for the normal (non-racing) case, and only costs an
           extra round trip on the rare occasion the race actually
           happens. */
        try {
          const verifyCart = await fetch('/cart.js').then(r => r.json())
          const stillPresent = {}
          Object.keys(updates).forEach(key => {
            const line = verifyCart.items.find(item => item.key === key)
            if (line && line.quantity > 0) stillPresent[key] = 0
          })
          if (Object.keys(stillPresent).length) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: stillPresent })
            })
          }
        } catch (err) {
          console.error('Error verifying bundle subscribe cleanup:', err)
        }
      } else if (!removeRes.ok && addRes.ok) {
        /* The remove failed but the (independent, concurrent) add still
           went through — without cleanup the cart would now hold BOTH
           the original one-time lines AND the new subscription lines
           (a duplicate of the same bundle). Undo the add using the keys
           Shopify just handed back for the lines it created, then report
           the real (remove) failure. */
        const removeErrorMessage = await readErrorMessage(removeRes)
        let addedKeys = []
        try {
          const addedData = await addRes.json()
          addedKeys = (addedData.items || []).map(item => item.key).filter(Boolean)
        } catch (err) {
          addedKeys = []
        }

        if (addedKeys.length) {
          const undoUpdates = {}
          addedKeys.forEach(key => { undoUpdates[key] = 0 })
          const undoRes = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: undoUpdates })
          })
          if (!undoRes.ok) {
            throw new Error(
              "Could not remove the one-time bundle lines (".concat(removeErrorMessage, ") and could not undo the subscription lines either (")
                .concat(await readErrorMessage(undoRes), ") — check the cart")
            )
          }
        }

        throw new Error("Could not switch to a subscription (".concat(removeErrorMessage, ")"))
      } else {
        // Remove failed and/or add failed with nothing new left behind
        // by add (or add succeeded but was just undone above) — cart is
        // effectively unchanged already, so this is just the error path,
        // same behavior as before.
        const addErrorMessage = addRes.ok ? null : await readErrorMessage(addRes)

        if (!addErrorMessage) {
          // add.js itself was fine, remove.js failed — nothing to roll
          // back, cart still has the original one-time lines.
          throw new Error("Could not remove the one-time bundle lines: ".concat(await readErrorMessage(removeRes)))
        }

        /* add failed. If remove also succeeded, the one-time lines are
           gone and nothing replaced them — put them back instead of
           leaving the bundle short (Em: "les refills disparaissent"). */
        if (removeRes.ok) {
          const rollbackRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: oneTimePayload })
          })

          if (!rollbackRes.ok) {
            throw new Error(
              "Could not add the subscription lines (".concat(addErrorMessage, ") and could not restore the one-time lines either (")
                .concat(await readErrorMessage(rollbackRes), ") — check the cart")
            )
          }

          throw new Error("Could not switch to a subscription (".concat(addErrorMessage, ") — restored the one-time lines instead"))
        }

        // Both failed — cart is already back to its original state.
        throw new Error("Could not switch to a subscription (".concat(addErrorMessage, ")"))
      }

      // Card is already fading (see the top of this handler) — no extra
      // wait needed here, the fade has been running throughout the
      // network calls above.
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'))

      // Refreshes the full /cart page's own list too — see
      // refreshMainCartPage above for why this is needed alongside the
      // event above. Safe to do here (unlike on failure below) since the
      // conversion actually succeeded.
      await refreshMainCartPage()
    } catch (err) {
      console.error('Error converting bundle to subscription:', err)
      showError(button, err.message || String(err))
      // Deliberately NOT dispatching apps:product-added-to-cart here —
      // that triggers theme.js's AJAX refresh of .quick-cart__items,
      // which would wipe the error message above out again almost
      // immediately (it lives inside that element). Leaving it stale
      // until the drawer is closed/reopened is a fair trade for the
      // error actually being visible/screenshottable.
      //
      // .loading is only removed here (failure), not unconditionally in
      // a finally — Em: "it goes back off and disappear weirdly". On
      // success the button is mid fade-out (.bundle-subscribe-
      // transitioning) when apps:product-added-to-cart is dispatched;
      // theme.js's own quick-cart refresh from that event isn't awaited
      // here, so it can finish well after this handler's own promise
      // chain does. A finally block removed .loading as soon as OUR
      // chain resolved regardless of whether that swap had happened yet
      // — flipping the still-visible, still-fading switch back to "off"
      // right before the real content replaced it. Since a successful
      // conversion always replaces this exact button (either via that
      // event or refreshMainCartPage below), there's no case where it
      // needs to look interactive again — leaving .loading on a node
      // that's about to be discarded is harmless.
      button.classList.remove('loading')

      // The card was faded out shortly after the toggle was clicked (top
      // of this handler), before knowing whether the conversion would
      // actually succeed — undo that now so the card (and the error
      // message just added to it) is visible again. Also cancel the
      // delayed fade itself in case the request failed fast enough that
      // it hadn't fired yet — otherwise it would still go ahead and fade
      // out the card AFTER the error message was already shown.
      if (cardFadeTimeout) {
        clearTimeout(cardFadeTimeout)
      }
      if (card) {
        card.classList.remove('bundle-subscribe-transitioning')
        card.style.transition = ''
        card.style.opacity = ''
        card.style.transform = ''
      }
    }
  })
})()

/* -------- BUNDLE EDIT PAGE: "Update my cart" label + restore active subscription --------
   Two follow-ups to the "subscribe & save" toggle above, both scoped to
   the bundle-builder product page (sections/bundle-product.liquid),
   reached via the quick cart's edit-pencil link:

   1) That page's main button reuses one "Ready to add to cart" label
      (section.settings.checkout_button_proceed, data-bundle-atc-button
      -state="proceed") for both a fresh bundle and an edit of one
      already in the cart — reads as "Add to my cart" even when editing,
      which isn't clear (Em: "est-ce que le bouton peut dire 'update my
      cart'"). Swapped to a separate merchant-editable setting
      (checkout_button_update, carried in on the button's
      data-checkout-button-update-label attribute) whenever the URL has
      a ?bundle= param — i.e. whenever this page was reached by editing
      an existing bundle, not by adding a new one.

   2) The "subscribe & save" toggle above converts a bundle to a
      subscription via a native selling plan directly on the cart lines,
      never through this page's own ReCharge-based Purchase options
      widget — so re-opening this page via the edit-pencil link had no
      way to know a subscription was active, and "Subscribe & save"
      showed unchecked even though the cart lines were genuinely on a
      plan (Em: "je vois les refills... mais il n'y a pas de
      subscription sélectionnée"). sections/quick-cart.liquid now adds a
      #kiima_sub=<frequency> URL fragment to that edit link whenever the
      bundle currently has an active plan — <frequency> is that
      section's own "Subscribe & save toggle" > "Frequency (months)"
      setting, so it can't drift from whatever the toggle actually
      applies. This reads that fragment and clicks the Subscribe & save
      option's own label (rather than just checking the radio) so the
      widget's existing price/date/button-state listeners, which only
      fire on that click, run exactly as if the customer had clicked it
      themselves. */
;(() => {
  const applyEditModeState = () => {
    const isEditingBundle = new URLSearchParams(window.location.search).has('bundle')
    if (!isEditingBundle) return

    const submitButton = document.querySelector('[data-bundle-submit]')
    const updateLabel = submitButton?.dataset.checkoutButtonUpdateLabel
    const proceedLabel = submitButton?.querySelector('[data-bundle-atc-button-state="proceed"]')
    if (updateLabel && proceedLabel) {
      proceedLabel.textContent = updateLabel
    }

    const subMatch = window.location.hash.match(/kiima_sub=([^&]+)/)
    if (subMatch) {
      const targetFrequency = decodeURIComponent(subMatch[1])
      const subscriptionLabel = document.querySelector('[data-bsw-subscription-option] label.bsw__selector')
      if (subscriptionLabel) subscriptionLabel.click()

      /* Also select the matching frequency — nothing above sets it, so
         the widget was left on whatever's listed first in the section's
         "Selling plan frequencies" setting regardless of which plan is
         actually active (Em: "opens the bundle but it's selected 1
         month instead"). This dropdown's trigger button/list have no
         click handling wired up anywhere else in the theme at all — the
         underlying <select> is the only thing anything else reads
         (bundle-atc-form.js's submit, its own "next delivery" date) —
         so both the select AND the visible trigger label/list need
         setting by hand here to actually show the right frequency
         rather than just being functionally correct underneath. */
      const select = document.querySelector('[data-bsw-selling-plan-select]')
      if (select) {
        const frequencies = (select.getAttribute('data-bsw-select-selling-plan') || '')
          .split(',')
          .map(f => f.trim())
        const targetIndex = frequencies.indexOf(targetFrequency)

        if (targetIndex !== -1) {
          select.value = String(targetIndex)
          select.dispatchEvent(new Event('change'))

          const option = document.querySelector(
            "[data-bsw-frequency-option][data-value=\"".concat(targetIndex, "\"]")
          )
          const trigger = document.querySelector('[data-bsw-frequency-trigger-label]')
          if (option && trigger) {
            trigger.textContent = option.dataset.triggerLabel || option.textContent.trim()
            document.querySelectorAll('[data-bsw-frequency-option]').forEach(li => {
              li.setAttribute('aria-selected', li === option ? 'true' : 'false')
            })
          }
        }
      }
    }
  }

  // Runs after the bundle items themselves are restored from the same
  // URL (assets/is-custom.js's restoreBundleStateFromURL, invoked on a
  // 500ms delay) — a later delay here so this always has the final say
  // regardless of load order.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(applyEditModeState, 700))
  } else {
    setTimeout(applyEditModeState, 700)
  }
})()

/* -------- SMOOTH SCROLL FOR IN-PAGE LINKS --------
   Em: buttons linking to a section further down the same page (e.g. a
   link like "#shopify-section-template--..._video_with_text_...") now
   glide down instead of jumping. Done here rather than with CSS
   scroll-behavior on the whole page, because that would also animate the
   theme's own scroll resets (e.g. when the mobile menu or cart drawer
   closes, the page would visibly slide back to where you were).
   The stop point leaves room for the sticky announcement bar (see
   "scroll-margin-top" in custom.css).
---------------------------------------------------- */
;(function () {
  if (window.__kiimaSmoothAnchors) return
  window.__kiimaSmoothAnchors = true

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    var link = event.target.closest('a[href*="#"]')
    if (!link || link.target === '_blank') return

    var url
    try { url = new URL(link.href, window.location.href) } catch (e) { return }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return
    if (!url.hash || url.hash === '#') return

    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)))
    if (!target) return

    event.preventDefault()
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' })

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', url.hash)
    }
  })
})()

/* -------- FREE SHIPPING BAR: REDRAW AFTER A CART CHANGE --------
   Used by the cart page refresh above (after removing a bundle or using
   the "Subscribe & save" button). Same calculation and message as the
   theme's own bar, including the per-market amount (see the "MARKET-
   CURRENCY OVERRIDE CORRECTION" block above).
---------------------------------------------------------------- */
;(function () {
  var formatMoney = function (cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format)
    }
    format = format || '${{amount}}'
    var withDelimiters = function (value, decimals, thousands, decimalSeparator) {
      var parts = value.toFixed(decimals).split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
      return parts[1] ? parts[0] + decimalSeparator + parts[1] : parts[0]
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/)
    var value = cents / 100
    var amount
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': amount = withDelimiters(value, 0, ',', '.'); break
      case 'amount_with_comma_separator': amount = withDelimiters(value, 2, '.', ','); break
      case 'amount_no_decimals_with_comma_separator': amount = withDelimiters(value, 0, '.', ','); break
      default: amount = withDelimiters(value, 2, ',', '.')
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount)
  }

  window.kiimaRenderFreeShippingBar = function (node) {
    if (!node) return
    var cartTotal = parseInt(node.dataset.cartTotal, 10)
    var threshold = parseInt(node.dataset.threshold, 10)
    if (isNaN(cartTotal) || isNaN(threshold) || threshold <= 0) return

    if (node.dataset.thresholdIsLocalCurrency !== 'true') {
      var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1)
      threshold = Math.round(threshold * rate)
    }
    var thresholdInCents = threshold * 100

    var message = node.querySelector('.free-shipping-bar__message')
    var progressBar = node.querySelector('.free-shipping-bar__bar')

    if (cartTotal >= thresholdInCents) {
      node.classList.add('free-shipping-bar--success')
      if (message) message.innerText = node.dataset.freeShippingSuccessMessage || ''
    } else {
      var remainder = thresholdInCents - cartTotal
      var formatted = formatMoney(remainder, window.theme && window.theme.moneyFormat)
      if (message) {
        message.innerHTML = (node.dataset.freeShippingPendingMessage || '').replace(
          '{{ remaining_amount }}',
          '<span class="fs-body-bold">' + formatted + '</span>'
        )
      }
      node.classList.remove('free-shipping-bar--success')
    }

    if (progressBar) {
      var progress = cartTotal < thresholdInCents ? (cartTotal / thresholdInCents) * 100 : 100
      progressBar.style.setProperty('--progress-width', progress + '%')
    }
    node.classList.add('free-shipping-bar--loaded')
  }
})()